var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_c('VueRecaptcha',{ref:"recaptcha",attrs:{"sitekey":"6Lcfly0lAAAAAId6o8xQilFwq9LnHUb9oetJtpmy","load-recaptcha-script":true},on:{"verify":_vm.onVerify,"expired":_vm.onExpired}}),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }